export interface DialogData {
    title: string;
    message: string;
    confirmText: string;
    cancelText: string;
    saveText?: string;
    error: any;  // the reason this is set to any:  this could be a generic error or a typed error
}
